export default {
  vouchers: [],
  voucher: {}
}